import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Section from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/Section';
import SectionColumn
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/SectionColumn';
import moment from 'moment/moment';

const styles = () => ({
  root: {},
});

const DateRangeSection = ({
  startDate,
  endDate,
  onClickDateRange,
}) => {
  const dateRange = `${moment(startDate).format('MMM Do, YYYY')} - ${moment(endDate).format('MMM Do, YYYY')}`;

  return (
    <Section>
      <SectionColumn header={'Date Range'} value={dateRange} onClickValue={onClickDateRange} />
    </Section>
  );
};

DateRangeSection.defaultProps = {
  onClickDateRange: undefined,
};

DateRangeSection.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onClickDateRange: PropTypes.func,
};

export default withStyles(styles)(DateRangeSection);
